import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { handleBudgetRequestStatus } from "../../../utility/CommonFunctions";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";

export default function BudgetRequestDetail() {
    let { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);
    const [budgetReqData, setBudgetReqData] = useState();
    const [modalType, setModalType] = useState("");
    const [modal, setModal] = useState(false);
    const toggle = () => {
        setModal(!modal);
    };
    const [refreshLogs, setRefreshLogs] = useState(false);

    useEffect(() => {
        GetBudgetRequestDetail();
    }, [id]);

    const GetBudgetRequestDetail = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl?.get_site_budget_request_detail + `budgetRequestId=${id}`;
        callApi(API, options).then((response) => {
            setDataLoading(false);
            if (response?.status === true) {
                setBudgetReqData(response?.data);
            }
        });
    };

    const handleReqStatus = (status, reason = "") => {
        let postData = {
            from: "SCM",
            status: status === "Rejected" ? "rejected" : "approved",
            ...(status === "Rejected" && { rejectReason: reason }),
        };
        const option = {
            method: "POST",
            data: postData,
        };

        setIsLoading(true);
        callApi(
            apiUrl.update_site_budget_request_status + `budgetRequestId=${id}`,
            option
        )
            .then((res) => {
                setIsLoading(false);
                if (res?.status === true) {
                    toast.success(res?.message);
                    GetBudgetRequestDetail();
                    setRefreshLogs(true);
                } else {
                    toast.error(res?.message);
                }
                toggle();
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    };


    return (
        <>
            <>
                {dataLoading && <BgBlurLoader />}
                <div className="content container-fluid">
                    <MainHeading title="Budget Request Detail" showBackButton={true} />
                    <form action="">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <ul
                                                    className={
                                                        dataLoading
                                                            ? "row list-unstyled mt-4 loading-skeleton"
                                                            : "row list-unstyled mt-4"
                                                    }
                                                >
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Budget Request No. :-
                                                            </span>
                                                            {budgetReqData?.budgetRequestNumber || "--"}
                                                        </p>
                                                    </li>
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Status :-
                                                            </span>
                                                            {handleBudgetRequestStatus(
                                                                budgetReqData?.status
                                                            )}
                                                        </p>
                                                    </li>
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Site Name :-
                                                            </span>
                                                            {budgetReqData?.site?.name || "--"}
                                                        </p>
                                                    </li>

                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Date :-
                                                            </span>
                                                            {budgetReqData?.createdAt
                                                                ? moment(budgetReqData?.createdAt)?.format(
                                                                    "DD-MM-YYYY"
                                                                )
                                                                : "--"}
                                                        </p>
                                                    </li>
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Created By :-
                                                            </span>
                                                            {budgetReqData?.user?.name || "--"}{" "}
                                                            <span className="text-muted fs-5">{`(${budgetReqData?.user?.designation?.name}-${budgetReqData?.user?.department?.name})`}</span>
                                                        </p>
                                                    </li>
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Financial Year :-
                                                            </span>
                                                            {budgetReqData?.financialYear || "--"}
                                                        </p>
                                                    </li>
                                                    <li className="col-12 col-md-6 col-lg-4">
                                                        <p>
                                                            <span className="text-muted fs-5 d-block">
                                                                Request Type :-
                                                            </span>
                                                            {budgetReqData?.type == 1
                                                                ? "New Budget Request"
                                                                : "Budget Update Request"}

                                                        </p>
                                                    </li>
                                                    {budgetReqData?.rejectReason && (
                                                        <li className="col-12 col-md-6 col-lg-4">
                                                            <p>
                                                                <span className="text-muted fs-5 d-block">
                                                                    Reject Reason :-
                                                                </span>
                                                                {budgetReqData?.rejectReason || "--"}
                                                            </p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>

                                            {budgetReqData?.BudgetRequestHeads &&
                                                budgetReqData?.BudgetRequestHeads.length > 0 ? (
                                                Object.entries(
                                                    budgetReqData.BudgetRequestHeads.reduce((acc, head) => {
                                                        const type = head.type || "Other";
                                                        if (!acc[type]) acc[type] = [];
                                                        acc[type].push(head);
                                                        return acc;
                                                    }, {})
                                                ).map(([type, heads], groupIndex) => (
                                                    <div key={groupIndex} className="col-12 mb-5 border border-2 border-primary rounded-4 mt-4">
                                                        <div className="card h-100 border-0 shadow-sm rounded-4 bg-white">
                                                            <div className="card-header bg-transparent border-0 pt-4 px-4 pb-2">
                                                                <h4 className="mb-0 text-primary text-capitalize fw-semibold">
                                                                    {type.replace(/([A-Z])/g, " $1").trim()}
                                                                </h4>
                                                            </div>
                                                            <div className="card-body p-4">
                                                                {heads.map((head, index) => (
                                                                    <div className="card border-light shadow-sm custom-card rounded-4 mb-3" key={index}>
                                                                        <div className="card-body p-4">
                                                                            <div className="mb-4">
                                                                                <label className="form-label text-muted fs-6">
                                                                                    {head?.type === "staffBudget"
                                                                                        ? "Department"
                                                                                        : "Expense Head"}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control rounded-3 border-light bg-light text-dark shadow-sm py-2 px-3"
                                                                                    value={
                                                                                        head?.expensehead?.name ||
                                                                                        head?.department?.name ||
                                                                                        "--"
                                                                                    }
                                                                                    readOnly
                                                                                />
                                                                            </div>

                                                                            <div className="mb-4">
                                                                                <label className="form-label text-muted fs-6">
                                                                                    Expected Amount
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control rounded-3 border-light bg-light text-dark shadow-sm py-2 px-3"
                                                                                    value={head?.amount || "0"}
                                                                                    readOnly
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center mt-5">No Data Found</div>
                                            )}
                                        </div>


                                        {budgetReqData?.canChangeStatus && (
                                            <div className="d-flex align-items-center justify-content-end gap-3">
                                                <button
                                                    onClick={() => {
                                                        setModalType("reject");
                                                        toggle();
                                                    }}
                                                    className="btn btn-danger px-5"
                                                    type="button"
                                                >
                                                    Reject
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setModalType("approve");
                                                        toggle();
                                                    }}
                                                    className="btn btn-success px-5"
                                                    type="button"
                                                >
                                                    Approve
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div >

                <div className="col-12">
                    <div className="form-group mb-3">
                        <label htmlFor="totalLeavePerMonth" className="form-label">
                            Description
                        </label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={budgetReqData?.description || ""}
                            disabled={true}
                            config={{
                                toolbar: [],
                                readOnly: true,
                                image: {
                                    toolbar: [
                                        "imageStyle:alignLeft",
                                        "imageStyle:alignCenter",
                                        "imageStyle:alignRight",
                                        "|",
                                        "imageTextAlternative",
                                    ],
                                },
                            }}
                        />
                    </div>
                </div>

                <Logs
                    type={"budgetRequest"}
                    id={id}
                    refreshLogs={refreshLogs}
                    setRefreshLogs={setRefreshLogs}
                />
            </>
            <ApproveRejectModal
                modal={modal}
                toggle={toggle}
                submitHandler={(reason) =>
                    handleReqStatus(
                        modalType === "reject" ? "Rejected" : "Approved",
                        reason
                    )
                }
                isLoading={isLoading}
                actionType={modalType}
            />
        </>
    );
}
